var exports = {
  "Pe": "configurationItemContent__RjYN5o",
  "kt": "configurationItemTitle__rFXeef",
  "P_": "textContent__AOM2DM",
  "Yl": "textContentEmpty__VqT5F8",
};

module.exports = exports;
